import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  redirectingBack: {
    defaultMessage:
      'Redirecting you back to {clientName}{isAbbreviated, select, true {} other {.}}',
    id: 'PrettyRedirect.openingApp',
  },
  referBackHeadline: {
    id: 'PrettyReferBack.sorryHeadline',
    defaultMessage: "We're sorry, but we need your help.",
  },
  referBack: {
    id: 'PrettyReferBack.openingApp',
    defaultMessage:
      'To continue, you must close this screen and return to {clientName}{isAbbreviated, select, true {} other {.}}',
  },
});
